export default __webpack_public_path__ + "static/media/3B069A_2_0.e02efa06.ttf";